import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../app/store"
import { setNewUserDemo } from "../features/Auth/authSlice"

const StorylaneEmbed: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true)
  const dispatch = useAppDispatch()
  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://js.storylane.io/js/v2/storylane.js"
    script.async = true

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  const handleClose = () => {
    dispatch(setNewUserDemo(null as any))
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div
      className="sl-embed-container"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fff",
        overflow: "hidden",
      }}
    >
      {/* Close Button */}
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "5px",
          right: "15px",
          padding: "8px 14px",
          fontSize: "16px",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          zIndex: 10000,
          backgroundColor: "#F475A4",
          color: "#fff",
        }}
      >
        Skip
      </button>

      <div
        className="sl-embed"
        style={{
          position: "relative",
          width: "80%",
          height: "0",
          paddingBottom: "43%",
          maxHeight: "90vh",
          backgroundColor: "#fff",
          overflow: "hidden",
        }}
      >
        <iframe
          loading="lazy"
          src="https://app.storylane.io/demo/f4dbqmcz7hjv"
          name="sl-embed"
          allow="fullscreen"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "none",
          }}
        ></iframe>
      </div>
    </div>
  )
}

export default StorylaneEmbed
